import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_ALL_DAY', function setIsAllDayInStore(isAllDay: boolean) {
    timeOffInputStore.isAllDay = isAllDay;
});
